<template>
    <div class="center-page">
        <div class="center-head">
            <div class="f-14 mb-10">当前余额
                <span class="color-red">{{totalMoney}}</span>（元）
                <el-link type="primary" @click="money= +totalMoney">全部提现</el-link>
            </div>
            <div>
                <el-input-number class="mr-10" v-model="money" :min="0" :max="+totalMoney" :step="0.01"
                                 size="mini"></el-input-number>
                <el-select v-model="payId" size="mini" class="mr-10" placeholder="请选择提现方式">
                    <el-option v-for="(item,index) in payType" :key="index" :label="item.account" :value="item.id">
                        <div class="select-row">
                            <div class="select-item" v-if="item.mark === 0"><img src="./../../assets/img/pay1.png"
                                                                                 alt="">银行卡
                            </div>
                            <div class="select-item" v-if="item.mark === 1"><img src="./../../assets/img/zf.png" alt="">支付宝
                            </div>
                            <div class="select-item" v-if="item.mark === 2"><img src="./../../assets/img/pay2.png"
                                                                                 alt="">payoneer
                            </div>
                            <div class="select-item">{{item.account}}</div>
                            <div class="select-item">{{item.payee}}</div>
                        </div>
                    </el-option>
                </el-select>
                <el-button type="primary" size="mini" @click="fundsAdd">提现</el-button>
            </div>
        </div>
        <div class="right-title mt-20">余额记录</div>
        <el-collapse class="mt-20">
            <el-collapse-item v-for="(item,key,index) in list" :key="index" :title="key" :name="key">
                <div class="item-row" v-for="(it,i) in item" :key="i">
                    <div style="width: 200px;">{{it.reson}}</div>
                    <div class="select-item" v-if="it.mark === 0"><img src="./../../assets/img/pay1.png" alt="">银行卡
                    </div>
                    <div class="select-item" v-else-if="it.mark === 1"><img src="./../../assets/img/zf.png" alt="">支付宝
                    </div>
                    <div class="select-item" v-else-if="it.mark === 2"><img src="./../../assets/img/pay2.png" alt="">payoneer
                    </div>
                    <div class="select-item" v-else></div>
                    <div class="ml-a" :class="{'color-green':it.change<0, 'color-red':it.change>=0}">{{it.change}}</div>
                    <div class="ml-20 color-red" style="width: 160px;text-align: right">余额：{{it.balance}}</div>
                </div>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<script>
    export default {
        name: "withdraw",
        data() {
            return {
                totalMoney: 0,
                money: 0,
                payType: [],
                payId: '',
                list: ''
            }
        },
        created() {
            this.withdrawIndex();
            this.moneyDetail();
        },
        methods: {
            async withdrawIndex() {
                let [e, data] = await this.$api.withdrawIndexApi();
                let {money, ...params} = data.result
                this.totalMoney = money || 0;
                this.payType = Object.values(params)
            },
            async moneyDetail() {
                let [e, data] = await this.$api.moneyDetailApi();
                this.list = data.result[0]
            },
            async fundsAdd() {
                if (!this.payId) {
                    return this.$message.warning('请选择提现方式！')
                }
                let obj = this.payType.find(it => it.id === this.payId)
                let [e, data] = await this.$api.fundsAddApi({
                    mark: obj.mark,
                    money: 11,
                    payee: obj.payee
                })
                if (data.status) {
                    this.$message.success('提现申请成功！');
                    this.withdrawIndex();
                    this.moneyDetail();
                } else {
                    this.$message.warning(data.msg)
                }
            }
        },
    }
</script>

<style scoped lang="less">
    .center-head {

    }

    .select-row {
        width: 360px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .select-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            text-align: center;

            img {
                width: 20px;
                height: 20px;
                margin-right: 4px;
                object-fit: contain;
            }
        }
    }

    .item-row {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 40px;

        &:hover {
            border-bottom: 1px dashed rgba(228, 70, 70, 0.45);
        }

        .select-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            text-align: center;

            img {
                width: 20px;
                height: 20px;
                margin-right: 4px;
                object-fit: contain;
            }
        }
    }
</style>
